import { useTranslate } from "@similarweb/i18n-provider";
import { Stack } from "@similarweb/ui-components/foundations";

import { JOB_ENRICHMENT_LEVEL_OPTIONS } from "../../../constants";
import { useCrmEnrichmentContext } from "../../../contexts/CrmEnrichmentContext";
import type { CrmEnrichmentSource } from "../../../types/types";

import { StyledEnrichmentLevelRadioButton } from "./styles";

type Props = {
    isDisabled?: boolean;
    selectedEnrichmentSource: CrmEnrichmentSource;
    onSelectEnrichmentSource?: (source: CrmEnrichmentSource) => void;
};

const EnrichmentLevelRadio = ({ isDisabled = false, selectedEnrichmentSource, onSelectEnrichmentSource }: Props) => {
    const { translate } = useTranslate();

    const { i18nKeys } = useCrmEnrichmentContext();

    return (
        <Stack
            data-automation="enrichment-level-radio-container"
            gap="12px"
        >
            {JOB_ENRICHMENT_LEVEL_OPTIONS.map((option) => (
                <StyledEnrichmentLevelRadioButton
                    key={option}
                    data-automation={`enrichment-level-radio-${option}`}
                    itemDisabled={isDisabled}
                    itemLabel={translate(i18nKeys.enrichmentSource(option))}
                    itemSelected={selectedEnrichmentSource === option}
                    onClick={() => onSelectEnrichmentSource?.(option)}
                />
            ))}
        </Stack>
    );
};

export default EnrichmentLevelRadio;
